var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{
      name: 'app-flow',
      params: { appId: _vm.appId, flowId: _vm.identifier, mode: 'changelog', modeArg: _vm.changeId }
    }}},[_vm._v(_vm._s(_vm.$t('CHANGES_SINCE', { count: _vm.changesSince })))]),_vm._v(", "+_vm._s(_vm.relativeTime(_vm.change.ts || 0))+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }